import {filter, set} from "lodash";
import {Icon} from "@iconify/react";
import {sentenceCase} from "change-case";
import {useEffect, useState} from "react";
import iconEdit2 from "@iconify/icons-eva/edit-2-outline";
import {Link as RouterLink, useNavigate, useSearchParams} from "react-router-dom";
import moment from "moment";
// material
import {
  Card,
  Table,
  Button,
  Stack,
  Avatar,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  Switch,
  TextField,
  Grid,
} from "@mui/material";
// components
import Page from "src/components/Page";
import Scrollbar from "src/components/Scrollbar";
import SearchNotFound from "src/components/SearchNotFound";

import axios from "axios";
import StringUtil from "src/utils/StringUtil";
import MoreMenu from "src/components/common/MoreMenu";
import ListHead from "src/components/common/ListHead";
import ListToolbar from "src/components/common/ListToolbar";
import {alert} from "src/services/alert";
import MyPagination from "src/components/common/MyPagination";
import Label from "src/components/Label";
import plusFill from "@iconify/icons-eva/plus-fill";
import {asyncRequest} from "src/services/network";
import UserPicker from "src/components/common/UserPicker";
import UserInfo from "src/components/common/UserInfo";
import PaymentCodeDialog from "src/components/dialogs/PaymentCodeDialog";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";
import TiejunPicker from "src/components/common/TiejunPicker";
import CityPicker from "src/components/CityPicker";
import ChangeMerchantPwdDialog from "./components/ChangeAdminPwdDialog";
import MerchantInfoDrawer from "src/components/common/MerchantInfoDrawer";
import MerchantEdit from "./components/MerchantEdit";
import MerchantEditHF from "./components/MerchantEditHF";
import MerchantEditKF from "./components/MerchantEditKF";
import Confirm from "src/components/common/ConfirmDialog";
import ChangeMerchantVersionDialog from "./components/ChangeMerchantVersionDialog";
import BindMerchantParentDialog from "./components/BindMerchantParentDialog";
import ChannelDetailDialog from "./components/ChannelDetailDialog";
import ChannelDetailDialogNew from "./components/ChannelDetailDialogNew";
import AgentPicker from "src/components/common/AgentPicker";
import MyDateRangePicker from "src/components/common/my-date-range-picker/MyDateRangePicker";
import iconDelete from "@iconify/icons-eva/person-delete-fill";
import { Opacity } from "@mui/icons-material";
import { current } from "@reduxjs/toolkit";
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Tooltip, CircularProgress } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

const TABLE_HEAD = [
  {id: "merchant", label: "商户", alignRight: false, width: 150},
  {id: "entity", label: "主体信息", alignRight: false, width: 140},
  {id: "mini", label: "小程序管理员", alignRight: false, width: 140},
  {id: "parent", label: "推荐人", alignRight: false, width: 140},
  {id: "assets", label: "平台资产", alignRight: false, width: 160},
  {id: "districtAgent", label: "所属区代", alignRight: false, width: 100},
  {id: "status", label: "状态", alignRight: false, width: 80},
  {id: "at", label: "支付通道", alignRight: false, width: 110},
  {id: "action", label: "操作", alignRight: true, width: 60},
];

const moreMenus = [
  {title: "编辑", icon: iconEdit2},
  {title: "收款码", icon: iconEdit2},
  {title: "绑定超级管理员", icon: iconEdit2},
  {title: "修改推荐人", icon: iconEdit2},
  {title: "绑定区代", icon: iconEdit2},
  {title: "重新定位", icon: iconEdit2},
  // { title: "修改版本", icon: iconEdit2 },
  // { title: "配置三方商户", icon: iconEdit2 },
  //
  //
  // {title: "开通三方支付", icon: iconEdit2},
  // {title: "开通业务", icon: iconEdit2},
  // {title: "微信实名认证", icon: iconEdit2},
  // {title: "支付宝实名认证", icon: iconEdit2},
  // {title: "重新入驻", icon: iconEdit2},
  // {title: "添加微信特约商户appid", icon: iconEdit2},
  //
  //
  // { title: "添加分账接收方", icon: iconEdit2 },
  // { title: "查看最大分账比例", icon: iconEdit2 },
  // { title: "重置密码", icon: iconEdit2 },
];

export default function MerchantList() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();

  const [targetMerchant, setTargetMerchant] = useState({});
  const [targetMerchantNew, setTargetMerchantNew] = useState({});

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [action, setAction] = useState("");
  const [openHF, setOpenHF] = useState("");
  const [openKF, setOpenKF] = useState("");
  const [wxAuthData, setWxAuthData] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    sort: null,
    order: null,
    mid: "",
    name: "",
    hfUid: "",
    provinceId: null,
    cityId: null,
    districtId: searchParams.get("districtId") || "",
    version: null,
    createdAt: null,
    platformCode: 'huifu'
  });

  const [form, setForm] = useState({
    userType: "0",
    userName: 0,
    phone: "",
    certId: "",
    cardNo: "",
    certIdExpires: "",
    bankCode: "",
    cardName: "",
  });
  
  // 商户限额详情弹窗
  const [merchantLimitDialogOpen, setMerchantLimitDialogOpen] = useState(false);
  const [merchantLimitInfo, setMerchantLimitInfo] = useState(null);
  const [merchantLimitLoading, setMerchantLimitLoading] = useState(false);

  useEffect(() => {
    getItems();
  }, [filter]);

  useEffect(() => {
  }, [items]);

  async function getItems() {
    const {data, count} = await asyncRequest({
      path: "/merchant/list",
      data: filter,
    });

    setItems(data);
    setTotal(count);

    if (targetMerchant.mid) {
      const item = data.find((d) => d.mid == targetMerchant.mid);

      if (item) {
        setTargetMerchant(item);
      }
    }
    if (targetMerchantNew.mid) {
      const item = data.find((d) => d.mid == targetMerchantNew.mid);

      if (item) {
        setTargetMerchantNew(item);
      }
    }
  }
  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  function handleSizeChange(value) {
    setFilter({
      ...filter,
      size: value,
    });
  }
  
  // 查看商户限额详情
  async function handleViewMerchantLimit(mid) {
    setMerchantLimitDialogOpen(true);
    setMerchantLimitLoading(true);
    setMerchantLimitInfo(null);
    
    try {
      // 使用管理后台专用接口
      const { data } = await asyncRequest({
        method: "GET",
        path: `/system/config/xfq-limit/merchant-info?mid=${mid}`,
      });
      
      setMerchantLimitInfo(data);
    } catch (err) {
      console.error('获取商户限额信息失败:', err);
      alert(err?.message || err || '获取限额信息失败');
    } finally {
      setMerchantLimitLoading(false);
    }
  }

  const handleFilterByName = (event) => {
    setFilter({
      ...filter,
      search: event.target.value,
    });
  };
  const onrefreshClick = () => {
    getItems()
  };
  function handleRequestSort(value) {
    const order = filter.sort == value ? (filter.order == "asc" ? "desc" : "asc") : "asc";
    setFilter({
      ...filter,
      page: 0,
      sort: value,
      order,
    });
  }

  const handleMoreClick = (type, row) => {
    if (type === "编辑") {
      // navigate(`/merchant/edit/${row.mid}`, { state: row });
      // setTargetMerchant(row);
      // setAction("editMerchant");
      setTargetMerchant(row);
      setOpenHF("true");
    } else if (type === "绑定超级管理员") {
      UserPicker({
        onSelect(v) {
          // handleEdit(row.id, { categoryId: v.id });
          handleBindMiniAdmin(row.mid, v);
        },
      });
    } else if (type === "修改推荐人") {
      // TiejunPicker({
      //   onSelect(v) {
      //     handleBindParent(row.mid, v);
      //   },
      // });
      setTargetMerchant(row);
      setAction("bindParent");
    } else if (type === "绑定区代") {
      AgentPicker({
        condition: {
          // districtId: row.districtId,
        },
        onSelect(v) {
          // handleEdit(row.id, { categoryId: v.id });
          handleBindAgent(row.mid, v);
        },
      });
    } else if (type === "收款码") {
      setTargetMerchant(row);
      setAction("payCode");
    } else if (type === "配置三方商户") {
      // console.log(row, (row.idCardEndDate || "").replace(/\-/g, ""));
      setTargetMerchant(row);
      setForm({
        userType: "0",
        userName: row.realname,
        phone: row.mobile,
        certId: row.idCardNo,
        cardNo: row.accountNumber,
        certIdExpires: (row.idCardEndDate || "").replace(/\-/g, ""),
        bankCode: "",
        cardName: row.realname,
      });
      setAction("register");
      // handleRegister(row)
    } else if (type === "重置密码") {
      setTargetMerchant(row);
      setAction("changePwd");
    } else if (type === "添加分账接收方") {
      addReceiver(row.mid);
    } else if (type === "查看最大分账比例") {
      checkMaxFengzhangRatio(row.mid);
    } else if (type === "升级2.0") {
      if (row.version === 2) return alert("已经是2.0商户，无需升级");
      // setTargetMerchant(row);
      // setAction("upgrade");
      handleUpgrade(row);
    } else if (type === "修改版本") {
      setTargetMerchant(row);
      setAction("changeVersion");
    } else if (type === "开通三方支付") {
      applyHuifu(row.mid);
    } else if (type === "开通业务") {
      openHuifuBiz(row.mid);
    } else if (type === "微信实名认证") {
      authWxRealname(row.mid);
    } else if (type === "支付宝实名认证") {
      authAliRealname(row.mid);
    } else if (type === "添加微信特约商户appid") {
      addAppId(row.mid);
    } else if (type === "重新入驻") {
      Confirm({
        title: "确定重新入驻？",
        message: "不可逆，请谨慎操作",
        onConfirm() {
          applyHuifu(row.mid, true);
        },
      });
    } else if (type === "重新定位") {
      Confirm({
        title: "确定重新定位？",
        message: "不可逆，请谨慎操作",
        onConfirm() {
          positioningFun(row.mid);
        },
      });
    } else if (type === "同步汇付商户信息") {
      syncHuifuInfo(row.mid);
    }
  };
  const handleMoreClickNew = (type, row) => {
    if (type === "编辑") {
      // navigate(`/merchant/edit/${row.mid}`, { state: row });
      // setTargetMerchant(row);
      // setAction("editMerchant");
      setTargetMerchant(row);
      setOpenHF("true");
    } else if (type === "绑定超级管理员") {
      UserPicker({
        onSelect(v) {
          // handleEdit(row.id, { categoryId: v.id });
          handleBindMiniAdmin(row.mid, v);
        },
      });
    } else if (type === "修改推荐人") {
      // TiejunPicker({
      //   onSelect(v) {
      //     handleBindParent(row.mid, v);
      //   },
      // });
      setTargetMerchant(row);
      setAction("bindParent");
    } else if (type === "绑定区代") {
      AgentPicker({
        condition: {
          // districtId: row.districtId,
        },
        onSelect(v) {
          // handleEdit(row.id, { categoryId: v.id });
          handleBindAgent(row.mid, v);
        },
      });
    } else if (type === "收款码") {
      setTargetMerchant(row);
      setAction("payCode");
    } else if (type === "配置三方商户") {
      // console.log(row, (row.idCardEndDate || "").replace(/\-/g, ""));
      setTargetMerchant(row);
      setForm({
        userType: "0",
        userName: row.realname,
        phone: row.mobile,
        certId: row.idCardNo,
        cardNo: row.accountNumber,
        certIdExpires: (row.idCardEndDate || "").replace(/\-/g, ""),
        bankCode: "",
        cardName: row.realname,
      });
      setAction("register");
      // handleRegister(row)
    } else if (type === "重置密码") {
      setTargetMerchant(row);
      setAction("changePwd");
    } else if (type === "添加分账接收方") {
      addReceiver(row.mid);
    } else if (type === "查看最大分账比例") {
      checkMaxFengzhangRatio(row.mid);
    } else if (type === "升级2.0") {
      if (row.version === 2) return alert("已经是2.0商户，无需升级");
      // setTargetMerchant(row);
      // setAction("upgrade");
      handleUpgrade(row);
    } else if (type === "修改版本") {
      setTargetMerchant(row);
      setAction("changeVersion");
    } else if (type === "开通三方支付") {
      applyHuifuNew(row.mid);
    } else if (type === "开通业务") {
      openHuifuBizNew(row.mid);
    } else if (type === "微信实名认证") {
      authWxRealnameNew(row.mid);
    } else if (type === "支付宝实名认证") {
      authAliRealnameNew(row.mid);
    } else if (type === "添加微信特约商户appid") {
      addAppIdNew(row.mid);
    } else if (type === "重新入驻") {
      Confirm({
        title: "确定重新入驻？",
        message: "不可逆，请谨慎操作",
        onConfirm() {
          applyHuifuNew(row.mid, true);
        },
      });
    } else if (type === "重新定位") {
      Confirm({
        title: "确定重新定位？",
        message: "不可逆，请谨慎操作",
        onConfirm() {
          positioningFun(row.mid);
        },
      });
    } else if (type === "同步汇付商户信息") {
      syncHuifuInfoNew(row.mid);
    }
  };
  function handleUpgrade({name, mid}) {
    Confirm({
      message: `确定将商户 "${name}" 升级到2.0版本吗？`,
      async onConfirm() {
        const {msg} = await asyncRequest({
          path: "/merchant/upgrade",
          data: {mid},
        });

        alert(msg, "success");
        await getItems();
      },
    });
  }

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  async function handleRegister() {
    const {msg} = await asyncRequest({
      path: "/merchant/channel/register",
      data: {mid: targetMerchant.mid, mer: form},
    });

    alert(msg, "success");
    getItems();
    setAction("");
  }

  // 开通微信支付
  async function applyHuifu(mid, reEnter = false) {
    try {
      if (submitting) return;
      setSubmitting(true);
      const {msg} = await asyncRequest({
        path: "/merchant/huifu/apply",
        data: {
          mid,
          reEnter,
        },
        complete() {
          setSubmitting(false);
        },
      });

      alert(msg, "success");
      getItems();
    } catch (error) {
      // console.log("error", error);
      setSubmitting(false);
    }
  }
  async function applyHuifuNew(mid, reEnter = false) {
    try {
      if (submitting) return;
      setSubmitting(true);
      const {msg} = await asyncRequest({
        path: "/merchant/huifu2/apply",
        data: {
          mid,
          reEnter,
        },
        complete() {
          setSubmitting(false);
        },
      });

      alert(msg, "success");
      getItems();
    } catch (error) {
      // console.log("error", error);
      setSubmitting(false);
    }
  }
  // 重新定位
  async function positioningFun(mid) {
    try {
      console.log("positioningFun", mid);
      const {msg} = await asyncRequest({
        path: "/merchant/reset/location/"+mid,
        method: "get",
        data: {},
        complete() {
        },
      });

      alert(msg, "success");
      getItems();
    } catch (error) {
      // console.log("error", error);
    }
  }
  // 开通业务
  async function openHuifuBiz(mid) {
    try {
      if (submitting) return;
      setSubmitting(true);
      const {msg} = await asyncRequest({
        path: "/merchant/huifu/openBiz",
        data: {mid},
        complete() {
          setSubmitting(false);
        },
      });

      alert(msg, "success");
    } catch (error) {
      // console.log("error", error);
      setSubmitting(false);
    }
  }

  async function openHuifuBizNew(mid) {
    try {
      if (submitting) return;
      setSubmitting(true);
      const {msg} = await asyncRequest({
        path: "/merchant/huifu2/openBiz",
        data: {mid},
        complete() {
          setSubmitting(false);
        },
      });

      alert(msg, "success");
    } catch (error) {
      // console.log("error", error);
      setSubmitting(false);
    }
  }
  // reapply
  async function authWxRealname(mid) {
    const {msg} = await asyncRequest({
      path: "/merchant/huifu/authWxRealname",
      data: {mid},
    });

    alert(msg, "success");
    getItems();
  }
  async function authWxRealnameNew(mid) {
    const {msg} = await asyncRequest({
      path: "/merchant/huifu2/authWxRealname",
      data: {mid},
    });

    alert(msg, "success");
    getItems();
  }
  async function authAliRealname(mid) {
    const {msg} = await asyncRequest({
      path: "/merchant/huifu/authAliRealname",
      data: {mid},
    });

    alert(msg, "success");
    getItems();
  }
  async function authAliRealnameNew(mid) {
    const {msg} = await asyncRequest({
      path: "/merchant/huifu2/authAliRealname",
      data: {mid},
    });

    alert(msg, "success");
    getItems();
  }


  // 手动实名认证
  async function handleConfirmWxAuth(mid) {
    const {msg} = await asyncRequest({
      path: "/merchant/huifu/confirmWxAuth",
      data: {mid},
    });

    alert(msg, "success");
    getItems();
  }
  async function handleConfirmWxAuthNew(mid) {
    const {msg} = await asyncRequest({
      path: "/merchant/huifu2/confirmWxAuth",
      data: {mid},
    });

    alert(msg, "success");
    getItems();
  }

  async function handleConfirmAliAuth(mid) {
    const {msg} = await asyncRequest({
      path: "/merchant/huifu/confirmAliAuth",
      data: {mid},
    });

    alert(msg, "success");
    getItems();
  }
  async function handleConfirmAliAuthNew(mid) {
    const {msg} = await asyncRequest({
      path: "/merchant/huifu2/confirmAliAuth",
      data: {mid},
    });

    alert(msg, "success");
    getItems();
  }
  async function syncHuifuInfo(mid) {
    const {msg} = await asyncRequest({
      path: "/merchant/huifu/sync",
      data: {mid},
    });

    alert(msg, "success");
    getItems();
  }

  async function syncHuifuInfoNew(mid) {
    const {msg} = await asyncRequest({
      path: "/merchant/huifu2/sync",
      data: {mid},
    });

    alert(msg, "success");
    getItems();
  }
  async function addAppId(mid) {
    const {msg} = await asyncRequest({
      path: "/merchant/huifu/addAppId",
      data: {mid},
    });

    alert(msg, "success");
  }
  async function addAppIdNew(mid) {
    const {msg} = await asyncRequest({
      path: "/merchant/huifu2/addAppId",
      data: {mid},
    });

    alert(msg, "success");
  }
  async function handleBindMiniAdmin(mid, user) {
    const {msg} = await asyncRequest({
      path: "/merchant/bindAdmin",
      data: {mid, uid: user.uid},
    });

    alert(msg, "success");
    getItems();
  }
  async function handleBindParent(mid, user) {
    const {msg} = await asyncRequest({
      path: "/merchant/bindParent",
      data: {mid, uid: user.uid},
    });

    alert(msg, "success");
    getItems();
  }

  async function handleBindAgent(mid, agent) {
    const {msg} = await asyncRequest({
      path: "/merchant/bindAgent",
      data: {mid, agentId: agent.id},
    });

    alert(msg, "success");
    getItems();
  }

  async function addReceiver(mid) {
    const {msg} = await asyncRequest({
      path: "/merchant/addReceiver",
      data: {mid},
    });

    alert(msg, "success");
  }

  async function checkMaxFengzhangRatio(mid) {
    const {msg, data} = await asyncRequest({
      path: "/merchant/checkMaxFenzhangRatio",
      data: {mid},
    });

    alert(data, "success");
  }

  async function toggleEnabled(mid) {
    const {data} = await asyncRequest({
      path: "/merchant/toggleEnabled",
      data: {
        mid,
      },
    });

    const item = items.find((it) => it.mid == mid);
    item.status = item.status==1?0:1
    item.isEnabled = !item.isEnabled;
    setItems([...items]);
  }

  async function toggleShow(mid) {
    const {data} = await asyncRequest({
      path: "/merchant/toggleShow",
      data: {
        mid,
      },
    });

    const item = items.find((it) => it.mid == mid);
    item.isShow = !item.isShow;
    setItems([...items]);
  }

  function handleFilterChange(ki, val) {
    setFilter({
      ...filter,
      [ki]: val,
      page: 0,
    });
  }
  function hf2againFun(row) {
      setTargetMerchant(row);
      setAction("channel2");
    //   if(row.hf2ShowStatus==0){
    //     Confirm({
    //     message: "确定汇付②重新进件吗?",
    //     async onConfirm() {
    //       let param = {
    //         mid:row.mid,
    //         appType:'HUI_FU_HZ'
    //       }
    //       const { data, msg } = await asyncRequest({
    //         path: "/merchant/apply/auth2",
    //         data: param,
    //       });

    //       alert(msg, "success");
    //       getItems()
    //     },
    //   });
    // }else{
    //   setTargetMerchant(row);
    //   setAction("channel2");
    // }
  }
  async function handleExport() {
    const {msg} = await asyncRequest({
      path: "/merchant/export",
      data: filter,
    });

    alert(msg, "success");
  }

  function renderPaymentApp(row) {
    const {application, kfApp, mid} = row;
    let hfText = "";
    let hfText2 = "";
    let listObj = {
      class99: "审核失败",
      class0: "未开通",
      class1: "审核中",
      class2: "待签约",
      class3: "待认证",
      class9: "已完成",
    }
    const commonHoverStyles = {
      opacity: 0.8,
      cursor: 'pointer'
    };
    // 定义每个状态对应的样式
    const statusStyles = {
      class99: {
        backgroundColor: '#ff4a00',
        color: '#fff',
        '&:hover': commonHoverStyles
      },
      class0: {
        backgroundColor: '#ccc',
        color: '#fff',
        '&:hover': commonHoverStyles
      },
      class1: {
        backgroundColor: '#fb9d6f',
        color: '#fff',
        '&:hover': commonHoverStyles
      },
      class2: {
        backgroundColor: '#29e1b3',
        color: '#fff',
        '&:hover':commonHoverStyles
      },
      class3: {
        backgroundColor: '#009fe8',
        color: '#fff',
        '&:hover': commonHoverStyles
      },
      class9: {
        backgroundColor: '#01d463',
        color: '#fff',
        '&:hover': commonHoverStyles
      },
    };
    let objName = 'class'+row.hfShowStatus
    let objName2 = 'class'+row.hf2ShowStatus
    hfText ='汇付①'+listObj[objName]
    if(listObj[objName2] == '未开通'){
      hfText2 ='汇付②重新进件'
    }else{
      hfText2 ='汇付②'+listObj[objName2]
    }

    let kfText = "";
    let kfobjName = 'class'+row.kfShowStatus
    kfText ='快付'+listObj[kfobjName]
    return (
      <Stack alignItems="center">
        <Stack direction="row" alignItems="center" sx={{display:"block"}}>
          <Button
            variant="contained"
            size="small"
            sx={statusStyles[objName] || {}}  // 使用 sx 属性动态应用样式
            onClick={() => {
              setTargetMerchant(row);
              setAction("channel");
            }}>
            {hfText}
          </Button>
        </Stack>
        <Stack direction="row" alignItems="center" sx={{display:"block",marginTop:"10px"}}>
          {/* <Button
            variant="contained"
            size="small"
            sx={statusStyles[objName2] || {}}  // 使用 sx 属性动态应用样式
            onClick={() => {
              setTargetMerchant(row);
              setAction("channel2");
              hf2againFun()
            }}> */}
          <Button
            variant="contained"
            size="small"
            sx={statusStyles[objName2] || {}}  // 使用 sx 属性动态应用样式
            onClick={() => {
              hf2againFun(row)
            }}>
            {hfText2}
          </Button>
        </Stack>
        <Stack direction="row" alignItems="center" sx={{display:"block",marginTop:"10px"}}>
          <Button
            variant="contained"
            size="small"
            sx={statusStyles[kfobjName] || {}}  // 使用 sx 属性动态应用样式
            onClick={() => {
              setTargetMerchant(row);
              setOpenKF("true");
            }}>
            {kfText}
          </Button>
        </Stack>
      </Stack>
    );
  }

  const isUserNotFound = items.length === 0;

  return (
    <>
      <Page title="商户列表">
        <Container maxWidth="2000px">
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              商户列表
            </Typography>

            <Button
              variant="contained"
              // component={RouterLink} to="/merchant/add"
              onClick={() => {
                setTargetMerchant({});
                setAction("addMerchant");
              }}
              startIcon={<Icon icon={plusFill}/>}
            >
              添加商户
            </Button>
          </Stack>

          <Card>
            <ListToolbar filterName={filter.search} onFilterName={handleFilterByName} onRefresh={getItems}
                         onExport={handleExport}>
              <Grid container spacing={1}>
                <Grid item xs={6} sm={4} md={2}>
                  <TextField
                    label="商户ID"
                    size="small"
                    placeholder="商户ID"
                    autoComplete="off"
                    fullWidth
                    value={filter.mid}
                    onChange={(e) => handleFilterChange("mid", e.target.value)}
                  />
                </Grid>

                <Grid item xs={6} sm={4} md={2}>
                  <TextField
                    size="small"
                    label="商户名称"
                    placeholder="商户名称"
                    autoComplete="off"
                    fullWidth
                    value={filter.name}
                    onChange={(e) => handleFilterChange("name", e.target.value)}
                  />
                </Grid>

                <Grid item xs={6} sm={4} md={2}>
                  <TextField
                    size="small"
                    label="汇付商户号"
                    placeholder="汇付商户号"
                    autoComplete="off"
                    fullWidth
                    value={filter.hfUid}
                    onChange={(e) => handleFilterChange("hfUid", e.target.value)}
                  />
                </Grid>

                <Grid item xs={6} sm={4} md={3}>
                  <CityPicker
                    code={filter.districtId}
                    onSelect={(val) => {
                      setFilter({
                        ...filter,
                        districtId: val.district ? val.district.id : null,
                        cityId: val.city ? val.city.id : null,
                        provinceId: val.province ? val.province.id : null,
                        page: 0,
                      });
                    }}
                  />
                </Grid>

                <Grid item xs={6} sm={4} md={3}>
                  <MyDateRangePicker
                    value={filter.createdAt}
                    onChange={(val) => {
                      setFilter({
                        ...filter,
                        createdAt: val,
                      });
                    }}
                  />
                </Grid>
              </Grid>
            </ListToolbar>

            <Scrollbar>
              <TableContainer sx={{minWidth: 800}}>
                <Table stickyHeader>
                  <ListHead headLabel={TABLE_HEAD} onRequestSort={handleRequestSort} orderBy={filter.sort}
                            order={filter.order}/>
                  <TableBody>
                    {items.map((row) => {
                      const {
                        mid,
                        name,
                        licenseName,
                        licenseNo,
                        parent,
                        rangli,
                        realname,
                        mobile,
                        createdAt,
                        status,
                        isShow,
                        uid,
                        admin,
                        user: merchantUser,
                        districtAgent
                      } = row;
                      const isItemSelected = selected.indexOf(realname) !== -1;

                      return (
                        <TableRow hover key={mid} tabIndex={-1} role="checkbox" selected={isItemSelected}
                                  aria-checked={isItemSelected}>
                          {/* 商户 */}
                          <TableCell align="left" sx={{width: 150}}>
                            <Stack spacing={0.3}>
                              <Button variant="text" size="small" onClick={() => { setTargetMerchant(row); setAction("viewDetail"); }}>
                                {mid}
                              </Button>
                              <Typography variant="body2" sx={{wordBreak: 'break-all', lineHeight: 1.3}}>{name}</Typography>
                              <Typography noWrap variant="caption" sx={{color: 'text.secondary'}}>{moment(createdAt).format("YYYY-MM-DD HH:mm")}</Typography>
                            </Stack>
                          </TableCell>

                          {/* 主体信息 */}
                          <TableCell align="left" sx={{width: 140}}>
                            <Stack spacing={0.3}>
                              <Typography variant="body2" sx={{wordBreak: 'break-all', lineHeight: 1.3}}>{licenseName || "-"}</Typography>
                              {licenseNo && <Typography noWrap variant="body2" sx={{fontSize: 12, color: 'text.secondary'}}>代码：{licenseNo}</Typography>}
                              <Typography noWrap variant="body2">法人：{realname || "-"}</Typography>
                              <Typography noWrap variant="body2">手机：{mobile || "-"}</Typography>
                            </Stack>
                          </TableCell>

                          {/* 小程序管理员 */}
                          <TableCell align="left" sx={{width: 140}}>
                            {admin && admin.user ? <UserInfo {...admin.user} enablePreview/> : <Typography variant="body2">-</Typography>}
                          </TableCell>

                          {/* 推荐人 */}
                          <TableCell align="left" sx={{width: 140}}>
                            {parent ? <UserInfo {...parent} enablePreview/> : <Typography variant="body2">-</Typography>}
                          </TableCell>

                          {/* 平台资产 */}
                          <TableCell align="left" sx={{width: 160}}>
                            <Stack spacing={0.3}>
                              <Stack direction="row" alignItems="center" spacing={0.5}>
                                <Typography noWrap variant="body2">系统贡献值：{Math.trunc(merchantUser?.contributionValue || 0)}</Typography>
                                <Tooltip title="查看当日权益金收款情况">
                                  <IconButton size="small" onClick={() => handleViewMerchantLimit(mid)}>
                                    <InfoIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              </Stack>
                              <Typography noWrap variant="body2">拼团贡献值：{Math.trunc(merchantUser?.pintuanContributionValue || 0)}</Typography>
                              <Typography noWrap variant="body2">让利：{rangli}%</Typography>
                            </Stack>
                          </TableCell>

                          {/* 所属区代 */}
                          <TableCell align="left" sx={{width: 100}}>
                            {districtAgent ? (
                              <Stack spacing={0.3}>
                                <Typography noWrap variant="body2">{districtAgent.district || "-"}</Typography>
                                <Typography noWrap variant="body2">{districtAgent.realname || "-"}</Typography>
                              </Stack>
                            ) : <Typography variant="body2">-</Typography>}
                          </TableCell>

                          {/* 状态 */}
                          <TableCell align="left" sx={{width: 80}}>
                            <Stack spacing={0.5}>
                              <Stack direction="row" alignItems="center" spacing={0.5}>
                                <Switch size="small" checked={status === 1} onChange={() => toggleEnabled(mid)}/>
                                <Typography variant="caption">启用</Typography>
                              </Stack>
                              <Stack direction="row" alignItems="center" spacing={0.5}>
                                <Switch size="small" checked={isShow} onChange={() => toggleShow(mid)}/>
                                <Typography variant="caption">显示</Typography>
                              </Stack>
                            </Stack>
                          </TableCell>

                          {/* 支付通道 */}
                          <TableCell align="left" sx={{width: 110}}>
                            {renderPaymentApp(row)}
                          </TableCell>

                          {/* 操作 */}
                          <TableCell align="right" sx={{width: 60}}>
                            <MoreMenu spread={false} menus={moreMenus}
                                      onMoreClick={(type) => handleMoreClick(type, row)}/>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                    {/* {emptyRows > 0 && (
                    <TableRow style={{ height: 50 * emptyRows }}>
                      <TableCell colSpan={2} />
                    </TableRow>
                  )} */}
                  </TableBody>
                  {isUserNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{py: 5}}>
                          <SearchNotFound searchQuery={filter.search}/>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange}
                          onSizeChange={handleSizeChange}/>
          </Card>
        </Container>

        {action === "payCode" && (
          <PaymentCodeDialog
            open={true}
            merchant={targetMerchant}
            onClose={() => {
              setAction("");
              setTargetMerchant({});
            }}
          />
        )}

        {action === "register" && (
          <FormDialog title={action === "add" ? "配置第三方商户" : "配置第三方商户"} open={!!action}
                      onClose={() => setAction()} onConfirm={handleRegister}>
            <FormItem title="法人姓名" required>
              <TextField fullWidth placeholder="请输入法人姓名" autoComplete="off" id="userName" value={form.userName}
                         size="small" onChange={(e) => handleIptChange("userName", e.target.value)}/>
            </FormItem>
            <FormItem title="法人手机号" required>
              <TextField fullWidth placeholder="请输入法人手机号" type="number" autoComplete="off" id="phone"
                         value={form.phone} size="small" onChange={(e) => handleIptChange("phone", e.target.value)}/>
            </FormItem>
            <FormItem title="身份证" required>
              <TextField fullWidth placeholder="请输入身份证" autoComplete="off" id="certId" value={form.certId}
                         size="small" onChange={(e) => handleIptChange("certId", e.target.value)}/>
            </FormItem>
            <FormItem title="身份证有效期" required>
              <TextField fullWidth placeholder="请输入身份证有效期" type="number" autoComplete="off" id="certIdExpires"
                         value={form.certIdExpires} size="small"
                         onChange={(e) => handleIptChange("certIdExpires", e.target.value)}/>
            </FormItem>

            <FormItem title="银行卡姓名" required>
              <TextField fullWidth placeholder="银行卡姓名" autoComplete="off" id="cardName" value={form.cardName}
                         size="small" onChange={(e) => handleIptChange("cardName", e.target.value)}/>
            </FormItem>
            <FormItem title="银行卡卡号" required>
              <TextField fullWidth placeholder="银行卡卡号" type="number" autoComplete="off" id="cardNo"
                         value={form.cardNo} size="small" onChange={(e) => handleIptChange("cardNo", e.target.value)}/>
            </FormItem>
          </FormDialog>
        )}
      </Page>

      {action == "changePwd" && <ChangeMerchantPwdDialog open merchant={targetMerchant} onClose={() => setAction("")}/>}
      {action == "viewDetail" &&
        <MerchantInfoDrawer open mid={targetMerchant.mid} logo={targetMerchant.logo} name={targetMerchant.name}
                            onClose={() => setAction("")}/>}
      {(action == "editMerchant" || action == "addMerchant") && (
        <MerchantEdit
          open
          item={targetMerchant}
          onClose={() => setAction("")}
          onFinish={() => {
            getItems();
            setAction("");
          }}
        />
      )}
      {action == "changeVersion" && (
        <ChangeMerchantVersionDialog
          open
          merchant={targetMerchant}
          onFinish={() => {
            getItems();
            setAction("");
          }}
          onClose={() => setAction("")}
        />
      )}

      {action == "channel"  &&(
        <ChannelDetailDialog
          open
          merchant={targetMerchant}
          onAuthWx={(mid) => {
            authWxRealname(mid);
          }}
          onAuthAli={(mid) => {
            authAliRealname(mid);
          }}
          onConfirmWxAuth={(mid) => {
            handleConfirmWxAuth(mid);
          }}
          onConfirmAliAuth={(mid) => {
            handleConfirmAliAuth(mid);
          }}
          onBtnFun={(type,row) => {
            handleMoreClick (type,row);
          }}
          onFinish={() => {
            getItems();
            // setAction("");
          }}
          onClose={() => setAction("")}
        />
      )}
      {action == "channel2" &&(
        <ChannelDetailDialogNew
          open
          merchant={targetMerchant}
          onAuthWx={(mid) => {
            authWxRealnameNew(mid);
          }}
          onAuthAli={(mid) => {
            authAliRealnameNew(mid);
          }}
          onConfirmWxAuth={(mid) => {
            handleConfirmWxAuthNew(mid);
          }}
          onConfirmAliAuth={(mid) => {
            handleConfirmAliAuthNew(mid);
          }}
          onBtnFun={(type,row) => {
            handleMoreClickNew (type,row);
          }}
          onFinish={() => {
            getItems();
            // setAction("");
          }}
          onClose={() => setAction("")}
        />
      )}

      {action == "bindParent" && (
        <BindMerchantParentDialog
          open
          merchant={targetMerchant}
          onFinish={() => {
            getItems();
            setAction("");
          }}
          onClose={() => setAction("")}
        />
      )}

      {openHF=='true' && (
        <MerchantEditHF
            open
            item={targetMerchant}
            onClose={() => setOpenHF("")}
            onFinish={() => {
              getItems();
              setOpenHF("");
            }}
        />
      )}
      {openKF=='true' && (
        <MerchantEditKF
            open
            item={targetMerchant}
            onClose={() => setOpenKF("")}
            onFinish={() => {
              getItems();
              setOpenKF("");
            }}
            onBtnFun={(type,row) => {
              handleMoreClick (type,row);
            }}
            onrefreshKF={() =>
              onrefreshClick ()
            }
        />
      )}
      
      {/* 商户限额详情弹窗 */}
      <Dialog open={merchantLimitDialogOpen} onClose={() => setMerchantLimitDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>当日权益金收款情况</DialogTitle>
        <DialogContent>
          {merchantLimitLoading ? (
            <Stack alignItems="center" justifyContent="center" sx={{ py: 4 }}>
              <CircularProgress />
            </Stack>
          ) : merchantLimitInfo ? (
            <Stack spacing={2}>
              {merchantLimitInfo.limitEnabled ? (
                <>
                  <Typography variant="body1">
                    <strong>单日限额：</strong>{merchantLimitInfo.dailyLimit.toFixed(2)} 元
                  </Typography>
                  <Typography variant="body1" color="text.secondary">
                    <strong>当日已收：</strong>{merchantLimitInfo.todayUsed.toFixed(2)} 元
                  </Typography>
                  <Typography variant="body1" color="success.main">
                    <strong>当日剩余：</strong>{merchantLimitInfo.remainingLimit.toFixed(2)} 元
                  </Typography>
                </>
              ) : (
                <Typography variant="body1" color="text.secondary">
                  当前未开启商家权益金限额
                </Typography>
              )}
            </Stack>
          ) : (
            <Typography variant="body1" color="text.secondary">
              暂无数据
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setMerchantLimitDialogOpen(false)}>关闭</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
